import { getAltaDomain, validDevelopmentUrlRegEx } from 'utils/domains';
import { getWindowLocation } from 'utils/window';

export const getControlCenterOrigin = () => {
  const { origin } = getWindowLocation();

  // local development
  if (validDevelopmentUrlRegEx.test(origin)) {
    return origin;
  }

  // for deployed envs
  const domain = getAltaDomain();

  if (domain) {
    const nonProductionDomains = [
      'dev.alta.avigilon.com',
      'sandbox.alta.avigilon.com',
    ];

    if (nonProductionDomains.includes(domain)) {
      return `https://platinum.${domain}`;
    }

    return `https://access.${domain}`;
  }
};
